import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Informes/imprimirInformeIntervenciones`, method: 'POST', body: list, token: token})
}